import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'

type ModalProps = {
  children: React.ReactNode
  onClose: () => void
  isOpen: boolean
  preventClickToClose?: boolean
  className?: string
}

export default function Modal({
  children,
  isOpen,
  onClose,
  preventClickToClose,
  className = 'mx-auto w-full max-w-3xl transform overflow-hidden rounded-2xl bg-neutralWhite text-left align-middle shadow-xl transition-all',
}: ModalProps) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-40"
        onClose={preventClickToClose ? () => {} : onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="relative flex w-full items-center">
                <Dialog.Panel className={className}>{children}</Dialog.Panel>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
